import { render, staticRenderFns } from "./beneficiary-edit-select-country.vue?vue&type=template&id=79f6d282&"
import script from "./beneficiary-edit-select-country.vue?vue&type=script&lang=js&"
export * from "./beneficiary-edit-select-country.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports